import React from "react";
import "./custom.css";

import Header from "./components/Header";
import Footer from "./components/Footer";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppRoutes from "./AppRoutes";

export default function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        {AppRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          />
        ))}
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}